module.exports = __webpack_public_path__ + "public/images/partners/partner-5.51fea45e50f40868b10691e47edd6c71.png";